import React from "react";
import { Card, Button, Tooltip, Skeleton } from "antd";
import { SyncOutlined } from "@ant-design/icons";

function WidgetCardSkeleton({ rows = 12 }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <Skeleton.Avatar size={8} active style={{ flexShrink: 0 }} />
          <Skeleton.Input active size="small" style={{ flex: 1, height: 14 }} />
          <Skeleton.Input active size="small" style={{ width: 60, height: 12 }} />
        </div>
      ))}
    </div>
  );
}

function WidgetCard({ title, children, loading, extra, onRefresh }) {
  const headerExtra =
    extra ||
    (onRefresh ? (
      <Tooltip title="Aggiorna">
        <Button
          type="text"
          size="small"
          icon={<SyncOutlined />}
          onClick={onRefresh}
        />
      </Tooltip>
    ) : null);

  return (
    <Card
      title={title}
      extra={headerExtra}
      style={{ minHeight: 200, height: "100%", display: "flex", flexDirection: "column" }}
      className="widget-card"
      styles={{
        header: {
          background: "#fafafa",
          borderBottom: "1px solid #f0f0f0",
          padding: "12px 16px",
          minHeight: "auto",
          fontSize: 14,
          fontWeight: 600,
        },
        body: { padding: "16px 16px 16px 8px", flex: 1, display: "flex", flexDirection: "column", overflow: "visible" },
      }}
    >
      {loading ? <WidgetCardSkeleton /> : children}
    </Card>
  );
}

export default WidgetCard;
